import gsap from 'gsap'
import { forEach } from 'lodash'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const archiveGridRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const cards = selector('[data-motion-card]')

  const timeline = batchRevealAnimation({
    targets: cards,
    reverse,
    stagger: {
      amount: 0.2
    }
  })

  return () => {
    forEach(timeline, (animation) => animation.kill())
  }
}
